import React from "react";
import "./delete-confirmation-popup.scss";
import { DeleteConfirmationPopupProps } from "./delete-confirmation-props";
import trashIcon from "../../../assets/icons/trashIcon.svg";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";

/** Popup to confirm deletion of a resource by id with label context. */
const DeleteConfirmationPopup: React.FC<DeleteConfirmationPopupProps> = ({
  isOpen,
  onClose,
  handleDelete,
  deleteId,
  label,
}) => {
  if (!isOpen) return null;
  const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    "& .MuiDialogContent-root": {
      padding: theme.spacing(2),
    },
    "& .MuiDialogActions-root": {
      padding: theme.spacing(1),
    },
  }));
  return (
    <BootstrapDialog aria-labelledby="customized-dialog-title" open={true}>
      <div className="delete-popup">
        <div className="delete-popup-image-box">
          <div className="delete-popup-image">
            <div className="trashIcon-background">
              <img src={trashIcon} alt="trash-icon" />
            </div>
          </div>
        </div>
        <h4 className="delete-title">Delete {label}</h4>
        <p className="delete-message">Would you like to delete {label}?</p>
        <div className="delete-buttons">
          <button className="cancel-button" onClick={onClose}>
            Cancel
          </button>
          <button
            className="delete-button"
            onClick={() => handleDelete(deleteId)}
          >
            Delete
          </button>
        </div>
      </div>
    </BootstrapDialog>
  );
};

export default DeleteConfirmationPopup;
